import config from 'config';
import domainTokenMapping from 'config/domainTokens';
import find from 'lodash/find';

const getSystemUserAccessToken = (host?: string | string[]) => {
  const rawHost = Array.isArray(host) ? host[0] : host;
  const hostWithoutPort = rawHost?.split(':')[0];

  const candidates =
    config.public_vercel_env !== 'production'
      ? ['dev', rawHost, hostWithoutPort]
      : [rawHost, hostWithoutPort, 'dev'];

  const matched = find(domainTokenMapping, (tm) =>
    candidates.some((candidate) => !!candidate && tm.domains.includes(candidate)),
  );

  // Fallback to first configured token to keep local development functional.
  return matched?.token || domainTokenMapping[0]?.token;
};

export default getSystemUserAccessToken;
